import Icon from 'veui/components/Icon'
import { IconPlusSquareSolid } from 'dls-icons-vue'

Icon.register('plus-square-solid', IconPlusSquareSolid)
